import React from 'react';
import { Rule } from './DataQualityMain';
import { Pencil, Trash2 } from 'lucide-react';
import { 
  Snackbar, 
  Alert, 
  Table, 
  TableBody, 
  TableCell, 
  TableContainer, 
  TableHead, 
  TableRow, 
  Paper,
  IconButton,
  Chip,
  Box,
  CircularProgress
} from '@mui/material';
import ToggleOnIcon from '@mui/icons-material/ToggleOn';
import ToggleOffIcon from '@mui/icons-material/ToggleOff';
import axios from 'axios';


const ColumnLevelRules = ({ rules, searchTerm, fetchAllData, onEdit }) => {
  const [toast, setToast] = React.useState({ open: false, message: '', severity: 'success' });
  const [editingRuleId, setEditingRuleId] = React.useState(null); // Track which rule is being edited
  const [togglingRuleId, setTogglingRuleId] = React.useState(null); // Track which rule is being toggled
  console.log("rules", rules)
  const filteredRules = rules
    .filter(rule => rule.checkType === 'Column Level Check')
    .filter(rule =>
      (rule.attributes?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      rule.dimension?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      rule.keywords?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      rule.description?.toLowerCase().includes(searchTerm.toLowerCase()))
    );

  const handleDelete = async (ruleId) => {
    try {
      const BASE_URL = process.env.REACT_APP_API_URL;
      await axios.put(`${BASE_URL}/delete-rule-versioning/${ruleId}?check_type=Column%20Level%20Check`);
      if (typeof fetchAllData === 'function') fetchAllData();
      setToast({ open: true, message: 'Rule deleted successfully.', severity: 'success' });
    } catch (err) {
      setToast({ open: true, message: 'Failed to delete rule.', severity: 'error' });
    }
  };

  const handleToggle = async (ruleId,isActive) => {
    try {
      setTogglingRuleId(ruleId); // Set loading state for toggle
      const BASE_URL = process.env.REACT_APP_API_URL;
      
      await axios.put(`${BASE_URL}/rules/update_status/${ruleId}`);
      if(isActive){
      setToast({ open: true, message: 'Rule Disabled successfully.', severity: 'success' });

      }else{
      setToast({ open: true, message: 'Rule Enabled successfully.', severity: 'success' });

      }
      
      if (typeof fetchAllData === 'function') fetchAllData();
    } catch (err) {
      setToast({ open: true, message: 'Failed to toggle rule status.', severity: 'error' });
    } finally {
      setTogglingRuleId(null); // Clear loading state
    }
  };

  const handleEdit = async (ruleId) => {
    try {
      setEditingRuleId(ruleId); // Set loading state for this specific rule
      const BASE_URL = process.env.REACT_APP_API_URL;
      const res = await axios.get(`${BASE_URL}/rules/get_rule/${ruleId}`);
      if (typeof onEdit === 'function') {
        onEdit(res.data);
      }
    } catch (err) {
      setToast({ open: true, message: 'Failed to fetch rule details.', severity: 'error' });
    } finally {
      setEditingRuleId(null); // Clear loading state regardless of success/failure
    }
  };

  return (
    <div>
      <Snackbar open={toast.open} autoHideDuration={3000} onClose={() => setToast({ ...toast, open: false })} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
        <Alert onClose={() => setToast({ ...toast, open: false })} severity={toast.severity} sx={{ width: '100%' }}>
          {toast.message}
        </Alert>
      </Snackbar> 
      <TableContainer component={Paper} sx={{ 
        boxShadow: 'none', 
        border: '1px solid #e0e0e0',
        maxHeight: '384px',
        overflow: 'auto'
      }}>
        <Table>
          <TableHead sx={{
            position: 'sticky',
            top: 0,
            zIndex: 2,
            backgroundColor: '#0000a0'
          }}>
            <TableRow>
              <TableCell sx={{ 
                width: '16.67%', 
                fontWeight: 600, 
                fontSize: '12px', 
                color: 'white !important',
                backgroundColor: '#0000a0 !important',
                borderBottom: 'none'
              }}>Column Name</TableCell>
              <TableCell sx={{ 
                width: '16.67%', 
                fontWeight: 600, 
                fontSize: '12px', 
                color: 'white !important',
                backgroundColor: '#0000a0 !important',
                borderBottom: 'none'
              }}>Dimension</TableCell>
              <TableCell sx={{ 
                width: '25%', 
                fontWeight: 600, 
                fontSize: '12px', 
                color: 'white !important',
                backgroundColor: '#0000a0 !important',
                borderBottom: 'none'
              }}>Rule Description</TableCell>
              <TableCell sx={{ 
                width: '25%', 
                fontWeight: 600, 
                fontSize: '12px', 
                color: 'white !important',
                backgroundColor: '#0000a0 !important',
                borderBottom: 'none'
              }}>Keywords</TableCell>
              <TableCell sx={{ 
                width: '16.67%', 
                fontWeight: 600, 
                fontSize: '12px', 
                color: 'white !important',
                backgroundColor: '#0000a0 !important',
                borderBottom: 'none'
              }}>DQ Rule Check</TableCell>
              <TableCell sx={{ 
                width: '8.33%', 
                fontWeight: 600, 
                fontSize: '12px', 
                color: 'white !important',
                backgroundColor: '#0000a0 !important',
                borderBottom: 'none'
              }}>Actions</TableCell>
              <TableCell sx={{ 
                width: '8.33%', 
                fontWeight: 600, 
                fontSize: '12px', 
                color: 'white !important',
                backgroundColor: '#0000a0 !important',
                borderBottom: 'none'
              }}>Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
          {filteredRules.map((rule, index) => (
              <TableRow
              key={rule.id}
                sx={{
                  '&:hover': { backgroundColor: '#f9fafb' },
                  '&:nth-of-type(even)': { backgroundColor: '#fafafa' },
                  '&:nth-of-type(odd)': { backgroundColor: '#ffffff' }
                }}
            >
                <TableCell sx={{ color: '#111827', fontWeight: 500, wordBreak: 'break-word' }}>{rule.columnName}</TableCell>
                <TableCell sx={{ color: '#374151', wordBreak: 'break-word' }}>{rule.dimension}</TableCell>
                <TableCell sx={{ color: '#374151', wordBreak: 'break-word' }}>{rule.description}</TableCell>
                <TableCell sx={{ color: '#111827', fontSize: '14px', wordBreak: 'break-word' }}>{rule.keywords}</TableCell>
                <TableCell>
                  <Chip
                    label={rule.dqRuleCheck}
                    size="small"
                    variant="filled"
                    sx={{
                      backgroundColor: '#dbeafe',
                      color: '#1e40af',
                      fontSize: '12px',
                      fontWeight: 500
                    }}
                  />
                </TableCell>
                <TableCell>
                  <Box sx={{ display: 'flex', gap: 1 }}>
                    <IconButton
                      onClick={() => handleEdit(rule.id)}
                      size="small"
                      disabled={editingRuleId === rule.id}
                      sx={{ 
                        color: editingRuleId === rule.id ? '#9ca3af' : '#2563eb',
                        '&:hover': {
                          color: editingRuleId === rule.id ? '#9ca3af' : '#1d4ed8'
                        }
                      }}
                      title={editingRuleId === rule.id ? 'Loading...' : 'Edit'}
                    >
                      {editingRuleId === rule.id ? (
                        <CircularProgress size={16} thickness={4} />
                      ) : (
                        <Pencil size={18} />
                      )}
                    </IconButton>
                    <IconButton
                      onClick={() => handleDelete(rule.id)}
                      size="small"
                      sx={{ color: '#dc2626' }}
                      title="Delete"
                    >
                  <Trash2 size={18} />
                    </IconButton>
                  </Box>
                </TableCell>
                <TableCell>
                  <IconButton
                    onClick={() => handleToggle(rule.id,rule.isActive)}
                    size="small"
                    disabled={togglingRuleId === rule.id}
                    sx={{ 
                      color: rule.isActive ? '#10b981' : '#6b7280',
                      '&:hover': {
                        color: rule.isActive ? '#059669' : '#4b5563'
                      }
                    }}
                    title={rule.isActive ? 'Click to disable' : 'Click to enable'}
                  >
                    {togglingRuleId === rule.id ? (
                      <CircularProgress size={20} thickness={4} />
                    ) : rule.isActive ? (
                      <ToggleOnIcon sx={{ fontSize: 28 }} />
                    ) : (
                      <ToggleOffIcon sx={{ fontSize: 28 }} />
                    )}
                  </IconButton>
                </TableCell>
              </TableRow>
          ))}
          </TableBody>
        </Table>
      </TableContainer>
      
      {filteredRules.length === 0 && (
        <Box sx={{ textAlign: 'center', py: 6 }}>
          <p style={{ color: '#6b7280', fontSize: '18px' }}>No Rule Configured</p>
        </Box>
      )}
    </div>
  );
};

export default ColumnLevelRules;